import React from 'react';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';

Bugsnag.start({
  apiKey: '6602124fbd55359635fe29c5a11bd7a5',
  plugins: [new BugsnagPluginReact()],
  releaseStage: process.env.REACT_APP_ENV || process.env.NODE_ENV,
  enabledReleaseStages: ['staging', 'production'],
  appVersion: process.env.REACT_APP_VERSION,
});

export const ErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
